module.exports = __webpack_public_path__ + "static/media/insect(30).3c428f0e.PNG";